import React, { useEffect, useRef } from "react";
import { useSelector, useStore } from "react-redux";
import World from "../core/World";
import "./ThreeViewer.scss";
import loadingIcon from "../../../assets/icons/loading.svg";
import { selectLoading } from "../threeSlice";

const ThreeViewer = ({ children }) => {
  const containerRef = useRef();
  const store = useStore();
  const loading = useSelector(selectLoading);

  useEffect(() => {
    const container = containerRef.current;
    const world = new World(store);
    if (world.canvas && container) {
      container.appendChild(world.canvas);
    }
    return () => {
      if (world.canvas && container) {
        container.removeChild(world.canvas);
        world.dispose();
      }
    };
  }, [store]);

  return (
    <div className={`ThreeViewer${loading ? " loading" : ""}`} ref={containerRef}>
      {children}
      {loading && <img alt="loading" className="loading" src={loadingIcon} />}
    </div>
  );
};

export default ThreeViewer;
